// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.unstyled-button {
    color: inherit;
    font: inherit;
    text-align: inherit;
    line-height: inherit;
    -webkit-font-smoothing: inherit;
    -moz-osx-font-smoothing: inherit;
    -webkit-appearance: none;
    appearance: none;
    background: none;
    border: none;
    display: block;
    box-sizing: border-box;
    padding: 0;
    cursor: pointer;
    margin: 0;
}`, "",{"version":3,"sources":["webpack://./src/components/presentational/UnstyledButton/UnstyledButton.css"],"names":[],"mappings":"AAAA;IACI,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,oBAAoB;IACpB,+BAA+B;IAC/B,gCAAgC;IAChC,wBAAwB;IACxB,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;IACZ,cAAc;IACd,sBAAsB;IACtB,UAAU;IACV,eAAe;IACf,SAAS;AACb","sourcesContent":[".unstyled-button {\n    color: inherit;\n    font: inherit;\n    text-align: inherit;\n    line-height: inherit;\n    -webkit-font-smoothing: inherit;\n    -moz-osx-font-smoothing: inherit;\n    -webkit-appearance: none;\n    appearance: none;\n    background: none;\n    border: none;\n    display: block;\n    box-sizing: border-box;\n    padding: 0;\n    cursor: pointer;\n    margin: 0;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
